import { render } from "./_popupPainel.vue?vue&type=template&id=3d6a4415&scoped=true"
import script from "./_popupPainel.vue?vue&type=script&lang=js"
export * from "./_popupPainel.vue?vue&type=script&lang=js"

import "./_popupPainel.vue?vue&type=style&index=0&id=3d6a4415&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6a4415"]])

export default __exports__